export default __webpack_public_path__ + "static/how-to-fund-travel-with-kids-2551571e5334212b940172ecbc0c4d90.webp";